import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Flex, Text } from 'onefaceui-react-components';
import { formatDate, getResourceTo } from 'react/utils/utils';
import { CoordinateDetails } from '../styles';

export function CoordinatesPanel({ dataEvent }) {
  const formatSpeed = function (speed) {
    const formatter = new Monet.Format.DISTANCE(speed);
    const unitSystem = Monet.Session.User.unitSystem;
    let unitSystemStr = 'Greenmile.UnitMetrics.kilometersPerHour';

    if (unitSystem === 'NON_METRIC') {
      unitSystemStr = 'Greenmile.UnitMetrics.milesPerHour';
      formatter.convertKmToMiles();
    }
    return `${formatter.format().getValue()} ${getResourceTo(unitSystemStr)}`;
  };

  const coord = dataEvent?.startCoord;

  const engineON = getResourceTo(
    coord?.engineOn
      ? 'EventNotification.engine.on'
      : 'EventNotification.engine.off'
  );

  if(!coord) {
    return <EmptyState />;
  }

  return (
    <CoordinateDetails>
      <Flex gap={4} flexDirection="column" justifyContent="space-between">
        <Text size="xs">
          {getResourceTo('date')}:<strong>{formatDate(coord?.date)}</strong>
        </Text>
        <Text size="xs">
          {getResourceTo('map.popup.truck.vehiclespeed')}:
          <strong>{formatSpeed(coord?.speedKmh)}</strong>
        </Text>
        <Text size="xs">
          {getResourceTo('eventnotification.engine')}:
          <strong>{engineON}</strong>
        </Text>
        <Text size="xs">
          {getResourceTo('eventlog.latitude')}:
          <strong>{coord?.latitude || '-'}</strong>
        </Text>
        <Text size="xs">
          {getResourceTo('eventlog.longitude')}:
          <strong>{coord?.longitude || '-'}</strong>
        </Text>
      </Flex>
    </CoordinateDetails>
  );
}

CoordinatesPanel.propTypes = {
  dataEvent: PropTypes.object
};
